module.exports = __webpack_public_path__ + "static/media/abf4all-kickoff-poster.8d0383d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/abf4all-kickoff-poster.jpg
// module id = 119
// module chunks = 0